import React from "react";
import { Dropdown } from "semantic-ui-react";
import { EllipsisDropdown, ControlledPopup, USER_PERMISSIONS } from "dyl-components";
import RestrictedView from "shared/RestrictedView";

const TeamActionDropdown = ({ teamId, isTeamEmpty, onDeleteTeam, onEdit }) => {
    return (
        <EllipsisDropdown>
            <RestrictedView
                type="disabled"
                userPermission={USER_PERMISSIONS.TEAMS_EDIT}
            >
                <Dropdown.Item icon='pencil' onClick={() => { onEdit(teamId) }} text='Edit' />
            </RestrictedView>
            {isTeamEmpty && <RestrictedView
                type="controlledPopupDisabled"
                userPermission={USER_PERMISSIONS.TEAMS_DELETE}
            > <ControlledPopup
                    trigger={<Dropdown.Item icon='trash' text='Delete' />}
                    content={'Delete'}
                    onConfirm={() => onDeleteTeam(teamId)}
                    inverted
                /></RestrictedView>}
        </EllipsisDropdown>
    );
};

export default TeamActionDropdown;
